import {
    Image,
    View
} from "react-native";
import {
    type PresidentsCardProps,
} from "./types";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme,
    Text
} from "ncore-ui-kit";
import {
    getFirstAndLastWord,
    useDebouncedDimensions
} from "../../utils";

const PresidentCard = ({
    profilePhotoURL,
    fullName,
    term
}: PresidentsCardProps) => {
    const {
        windowWidth
    } = useDebouncedDimensions();


    const {
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();

    const avatarText = () => {
        const {
            first,
            last
        } = getFirstAndLastWord(fullName);

        if (first && last) {
            return `${first[0]}${last[0]}`;
        }
        if (first) {
            return `${first[0]}`;
        }
        return "";
    };

    return <View
        style={[
            stylesheet.container,
            {
                backgroundColor: colors.content.container.mid,
                width: windowWidth - spaces.spacingMd * 2,
                marginTop: spaces.spacingLg,
                borderRadius: radiuses.sm,
                padding: spaces.spacingLg
            }
        ]}
    >
        {profilePhotoURL ?
            <Image
                source={{
                    uri: profilePhotoURL
                }}
                resizeMode="cover"
                style={[
                    stylesheet.avatarImage,
                    {
                        borderRadius: radiuses.full
                    }
                ]}
            />
            :
            <View
                style={[
                    stylesheet.avatarPlaceholder,
                    {
                        backgroundColor: colors.content.container.warning,
                        borderRadius: radiuses.lg * 3,
                        marginRight: spaces.spacingLg
                    }
                ]}
            >
                <Text
                    style={stylesheet.textCenter}
                    variant="headlineLargeSize"
                    color="warning"
                >
                    {avatarText().toUpperCase()}
                </Text>
            </View>
        }
        <View>
            <Text
                style={{
                    marginTop: spaces.spacingSm
                }}
                variant="headlineSmallSize"
                color="high"
            >
                {fullName}
            </Text>
            <Text
                style={{
                    marginTop: spaces.spacingSm
                }}
                variant="bodyMediumSize"
                color="low"
            >
                {term}
            </Text>
        </View>
    </View>;
};
export default PresidentCard;
